var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { AssignmentStatusesByFilter, LabelByAssignmentsFilter, } from '../../../../constants/filters';
var FILTER_GROUPS_BY_ORDER = [
    "Active" /* Active */,
    "Scheduled" /* Scheduled */,
    "Ended" /* Ended */,
];
var sortByDate = function (assignment1, assignment2) {
    return (new Date(assignment2.startDate).valueOf() -
        new Date(assignment1.startDate).valueOf());
};
var sortAssignments = function (assignment1, assignment2, filter) {
    if (filter === "Ended" /* Ended */)
        return sortByDate(assignment1, assignment2);
    return 0;
};
export var groupAssignmentsByTableFilters = function (assignments) {
    return FILTER_GROUPS_BY_ORDER.reduce(function (acc, current) {
        var _a;
        return __assign(__assign({}, acc), (_a = {}, _a[current] = assignments
            .filter(function (el) { return AssignmentStatusesByFilter[current].includes(el.status); })
            .sort(function (a, b) { return sortAssignments(a, b, current); }), _a));
    }, {});
};
export var addTitleRowsIntoAssignments = function (groupedAssignments) {
    return FILTER_GROUPS_BY_ORDER.reduce(function (acc, current) {
        if (groupedAssignments[current].length === 0)
            return acc;
        var titleRow = {
            name: LabelByAssignmentsFilter[current],
        };
        return __spreadArray(__spreadArray(__spreadArray([], acc, true), [titleRow], false), groupedAssignments[current], true);
    }, []);
};
export var updateAssignmentInList = function (_a) {
    var assignments = _a.assignments, updatedAssignmentId = _a.updatedAssignmentId, params = _a.params;
    return assignments.map(function (el) {
        if (el.id === updatedAssignmentId)
            return __assign(__assign({}, el), params);
        return el;
    });
};
export var isAssignmentCell = function (data) { return data.id !== undefined; };
export var AssignmentsTableColumnWidth = {
    NAME: 358,
    DATES: 170,
    STUDENTS_COMPLETED: 137,
    STUDENTS_STRUGGLING: 71,
    ACTIONS: 182,
};
export var COMPLETED_ASSIGNMENTS_PER_PAGE = 4;
